import {ButtonGroup, HStack} from '@chakra-ui/react';
import type {FC, PropsWithChildren} from 'react';

type Props = PropsWithChildren;

const NavbarButtonGroup: FC<Props> = ({children}) => {
  return (
    <HStack spacing={`4`}>
      <ButtonGroup>{children}</ButtonGroup>
    </HStack>
  );
};

export default NavbarButtonGroup;
export type {Props as NavbarButtonGroupProps};
